export default __webpack_public_path__ + "static/media/discover-america-purple.258749ce.svg";